import { gql } from '@apollo/client';

const GET_HEARING_STAGES = gql`
    query hearingStages {
        hearingStages
    }
`;

export default GET_HEARING_STAGES;
